module.exports = __webpack_public_path__ + "static/media/logo_80_wo.68939799.png";